import { friendlyAssessmentNatureName, MetricNature } from '@upright/common/model/input/types';
import { TippyWithOriginalStyles } from '@upright/ui/common/generic/components/tooltips/default-tippy';
import { getIconAndColorByNature } from '@upright/ui/common/upright/core/impact-lenses/pais/common/icons';
import { CSSProperties } from 'react';

export function MetricNatureIcon(props: {
  nature: MetricNature | null;
  year?: number | null;
  style?: CSSProperties;
  className?: string;
}) {
  const { nature, year } = props;
  if (!nature) {
    return <></>;
  }
  const { Icon, color } = getIconAndColorByNature(nature);
  const natureName = friendlyAssessmentNatureName(nature);
  const tooltipText = `${natureName}${year ? `, ${year}` : ``}`;
  return (
    <TippyWithOriginalStyles appendTo={'parent'} delay={[300, 0]} content={<>{tooltipText}</>}>
      <div>
        <Icon
          className={props.className}
          style={{
            color,
            width: '1.0em',
            height: '1.0em',
            ...props.style,
          }}
        />
      </div>
    </TippyWithOriginalStyles>
  );
}
